/**
 * Открытие выбора файла: в браузере — обычный click(),
 * в Android WebView (APK) — нативный pickFiles (программный click() там не работает).
 */
export function isAndroidWebView(): boolean {
  const android = (window as Window & { Android?: { pickFiles?: (accept: string, multiple: string) => void } }).Android;
  return typeof android?.pickFiles === 'function';
}

export function openFileInput(input: HTMLInputElement | null | undefined): void {
  if (!input) return;

  const win = window as Window & {
    Android?: { pickFiles: (accept: string, multiple: string) => void };
    __pendingFileInput?: HTMLInputElement;
  };

  if (win.Android?.pickFiles) {
    win.__pendingFileInput = input;
    win.Android.pickFiles(input.accept || 'image/*', input.multiple ? 'true' : 'false');
    return;
  }

  input.click();
}
